import React from 'react'
import ScrollToTop from '../components/ScrollToTop'
import { Helmet } from 'react-helmet';


function VisionAndMision() {
    return (
        <>
            <ScrollToTop />

            <Helmet>
                <title>Визија и Мисија | Мал Сервис - онлајн продавница</title>
                <meta name="description" content="Запознајте се со нашата визија и мисија. Наша цел е да обезбедиме квалитетни авто делови, моторни масла и филтри за секое возило по достапни цени." />
                <meta name="keywords" content="визија, мисија, цели, вредности, мал сервис продавница, моторни масла, авто делови, квалитет" />
            </Helmet>

            <div className='w-full flex justify-center py-16 bg-gray-50 mt-6 '>
                <div className='mx-auto max-w-[800px] px-6 '>
                    <h1 className='text-5xl font-semibold text-center'>Визија</h1>
                    <p className='text-l mt-6  leading-relaxed'>
                        Нашата визија е да станеме водечкa онлајн продавница за моторни масла и филтри во регионот, обезбедувајќи брз, едноставен и сигурен процес на купување за секој сопственик на автомобил. Се стремиме кон иновација и континуиран развој на нашите услуги, со цел да понудиме најдобри решенија за одржување на автомобилите, при што ќе ја оптимизираме секоја фаза на корисничкото искуство – од изборот на производи до доставата на вашата адреса. Нашата цел е да бидеме првиот избор на купувачите кои сакаат квалитет, а воедно и незаменливо искуство при секоја нарачка, со најдобри цени.
                    </p>



                    <h2 className='text-5xl font-semibold text-center mt-12'>Мисија</h2>
                    <p className='text-l mt-6  leading-relaxed'>
                        Нашата мисија е да го издигнеме на едно повисоко ниво процесот на купување моторни масла и филтри преку интуитивен, оптимизиран вебсајт кој помага во процесот на избор на филтри само со одбирање на моделот на вашиот автомобил. На нашите купувачи им нудиме внимателно одбрани производи со врвен квалитет, јасни информации за цени, како и брза и сигурна достава. Нашата цел е да го заштедиме времето на нашите корисници, обезбедувајќи им брзо решение за одржување на нивните возила со сигурни и квалитетни производи.
                    </p>
                </div>
            </div>
        </>

    )
}

export default VisionAndMision
